import axios from 'axios'
import store from '../../store'

export default {
  data() {
    return {
      baseUrlLaudoMedico: store.state.baseUrlLaudoMedico
    }
  },
  methods: {
    TipoDeficienciaSolicitacaoCondicaoEspecificaPublicacao(tpDeficiencia) {
      this.carregaTexto(this.codeMensagem('C01'))
      return new Promise((resolve, reject) => {
        axios
          .get(
            this.baseUrlLaudoMedico +
              'TipoDeficienciaSolicitacaoCondicaoEspecificaPublicacao/ListarPorTpDeficienciaPublicacao/' +
              tpDeficiencia,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },

    RegrasExclusaoSolicitacaoCondicaoEspecifica(idSolicitacao) {
      this.carregaTexto(this.codeMensagem('C01'))
      return new Promise((resolve, reject) => {
        axios
          .get(
            this.baseUrlLaudoMedico +
              'RegrasExclusaoSolicitacaoCondicaoEspecificaPublicacao/ListarPorIdSolicitacaoPublicacao/' +
              idSolicitacao,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    ListarMetadadoSolicitacaoCondicaoComplemento(idSolicitacao) {
      this.carregaTexto(this.codeMensagem('C01'))
      return new Promise((resolve, reject) => {
        axios
          .get(
            this.baseUrlLaudoMedico +
              'MetadadoSolicitacaoCondicaoPublicacao/ListarPorIdSolicitacaoPublicacao/' +
              idSolicitacao,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    TipoDeficienciaSolicitacaoCondicaoEspecifica(tpDeficiencia) {
      this.carregaTexto(this.codeMensagem('C01'))
      return new Promise((resolve, reject) => {
        axios
          .get(
            this.baseUrlLaudoMedico +
              'TipoDeficienciaSolicitacaoCondicaoEspecifica/ListarPorTipoDeficiencia/' +
              tpDeficiencia,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    alimentarSolicitacaoEspecifica(solicitacao) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            this.baseUrlLaudoMedico +
              'SolicitacaoCondicaoEspecialPublicacao/AlimentarSolicitacaoEspecifica',
            solicitacao,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    inserirSolicitacaoCondicacaoEspecialPublicacao(solicitacao) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            this.baseUrlLaudoMedico + 'SolicitacaoCondicaoEspecialPublicacao/Adicionar',
            solicitacao,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    inserirMetadadoTipoDeficienciaPublicacao(solicitacao) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            this.baseUrlLaudoMedico + 'MetadadoTipoDeficienciaPublicacao/Adicionar',
            solicitacao,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    inserirTipoDeficienciaSolicitacaoCondicaoEspecificaPublicacao(solicitacao) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            this.baseUrlLaudoMedico +
              'TipoDeficienciaSolicitacaoCondicaoEspecificaPublicacao/Adicionar',
            solicitacao,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    listaMetaDadoTipoDeficienciaOficial() {
      this.carregaTexto(this.codeMensagem('C01'))
      return new Promise((resolve, reject) => {
        axios
          .get(
            this.baseUrlLaudoMedico + 'MetadadoTipoDeficiencia/ListarTodos',
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    listaMetaDadoTipoDeficienciaGenerica(idpublicacao) {
      this.carregaTexto(this.codeMensagem('C01'))
      return new Promise((resolve, reject) => {
        axios
          .get(
            this.baseUrlLaudoMedico +
              'MetadadoTipoDeficienciaPublicacao/ListarPorIdSolicitacaoCondicaoPublicacao/' +
              idpublicacao,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    listaNecessidadeSolicitacaoCondicaoEspecificaPublicacao(idpublicacao) {
      this.carregaTexto(this.codeMensagem('C01'))
      return new Promise((resolve, reject) => {
        axios
          .get(
            this.baseUrlLaudoMedico +
              'NecessidadeSolicitacaoCondicaoEspecificaPublicacao/ListarPorIdPublicacao/' +
              idpublicacao,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    },
    listarSolicitacaoCondicaoEspecialPublicacao(idPublicacao) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            this.baseUrlLaudoMedico +
              'SolicitacaoCondicaoEspecialPublicacao/ListarPorIdPublicacao/' +
              idPublicacao,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            const resposta = response.status == 204 ? null : response.data
            resolve(resposta)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(this.carregaTexto)
      })
    }
  },
  computed: {}
}
